import { Helmet } from 'react-helmet-async';

const StructuredDataDuocore = () => {
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "DUOCORE Copy Trade",
    "description": "Sistema revolucionário de copy trade com tecnologia dual-core. Processamento em 2 núcleos para máxima performance no trading automatizado.",
    "provider": {
      "@type": "Organization",
      "name": "QuantMake.AI",
      "url": "https://quantmake.ai",
      "logo": "https://quantmake.ai/lovable-uploads/quantmake-logo-principal-robo-trader-automatizado.png"
    },
    "serviceType": "Copy Trade Automatizado",
    "audience": {
      "@type": "Audience",
      "audienceType": "Traders e Investidores"
    },
    "offers": {
      "@type": "Offer",
      "name": "DUOCORE Copy Trade Premium",
      "description": "Acesso completo ao sistema DUOCORE com tecnologia dual-core",
      "priceRange": "R$ 497 - R$ 997",
      "availability": "https://schema.org/InStock"
    }
  };

  const personDaniloSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Danilo Leandro",
    "jobTitle": "Especialista em DUOCORE Copy Trade",
    "description": "Engenheiro especialista em algoritmos DUOCORE com 18 anos de experiência em trading automatizado",
    "image": "https://quantmake.ai/lovable-uploads/quantmake-danilo-leandro-especialista-robo-trader-engenheiro.png",
    "worksFor": {
      "@type": "Organization",
      "name": "QuantMake.AI"
    },
    "knowsAbout": ["Trading Automatizado", "Algoritmos DUOCORE", "Copy Trade", "Mercado Futuro B3"]
  };

  const personAndreaSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Andréa Melo",
    "jobTitle": "Analista CNPI-T especialista DUOCORE",
    "description": "Analista CNPI-T especializada em algoritmos DUOCORE e copy trade automatizado",
    "image": "https://quantmake.ai/lovable-uploads/quantmake-andrea-melo-analista-cnpi-day-trade-especialista.png",
    "worksFor": {
      "@type": "Organization",
      "name": "QuantMake.AI"
    },
    "knowsAbout": ["Copy Trade", "Análise Técnica", "DUOCORE", "Day Trade", "Mercado Futuro"]
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://quantmake.ai"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "DUOCORE Copy Trade",
        "item": "https://quantmake.ai/duocore"
      }
    ]
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "O que é o DUOCORE Copy Trade?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "O DUOCORE é um sistema revolucionário de copy trade com tecnologia dual-core, oferecendo processamento em 2 núcleos para máxima performance no trading automatizado no mercado futuro B3."
        }
      },
      {
        "@type": "Question",
        "name": "Como funciona a tecnologia dual-core do DUOCORE?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A tecnologia dual-core do DUOCORE utiliza dois núcleos de processamento independentes para análise e execução simultânea, garantindo maior velocidade e precisão nas operações de copy trade."
        }
      },
      {
        "@type": "Question",
        "name": "Qual é a margem mínima para operar com DUOCORE?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A margem mínima recomendada para operar com o DUOCORE Copy Trade é de R$ 20.000, garantindo maior segurança e potencial de retorno nas operações."
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(personDaniloSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(personAndreaSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredDataDuocore;